export default "__VITE_ASSET__DNZBcj9L__"